var map = {
	"./anbutter.png": 60,
	"./anpan.png": 61,
	"./baguette.png": 62,
	"./castella.png": 63,
	"./cheesecake.png": 64,
	"./chocolatine.png": 65,
	"./cinnamonroll.png": 66,
	"./creampuff.png": 67,
	"./croffle.png": 68,
	"./cupcake.png": 69,
	"./financier.png": 70,
	"./loafbread.png": 71,
	"./macaron.png": 72,
	"./pretzel.png": 73,
	"./scone.png": 74,
	"./soboro.png": 75
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;